'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'screen-users';
var width = 640;
var height = 512;
var aliases = ["users-class"];
var unicode = 'f63d';
var svgPathData = 'M56 224C69.25 224 80 213.3 80 200v-144c0-4.4 3.6-8 8-8h464c4.4 0 8 3.6 8 8v144C560 213.3 570.7 224 584 224S608 213.3 608 200v-144C608 25.07 582.9 0 552 0H88C57.07 0 32 25.07 32 56v144C32 213.3 42.75 224 56 224zM544 256C508.8 256.2 480.2 284.7 480.2 320S508.8 383.8 544 383.1C579.2 383.8 607.8 355.3 607.8 320S579.2 256.2 544 256zM544.2 335.1C535.4 335.9 528.3 328.8 528.3 320c0-8.717 7.041-15.85 15.73-15.97C552.7 304.2 559.7 311.3 559.7 320C559.7 328.8 552.6 335.9 544.2 335.1zM343.8 416h-47.5C256.4 416 224 449.5 224 490.7C224 502.4 233.3 512 244.8 512h150.3C406.7 512 416 502.4 416 490.7C416 449.5 383.6 416 343.8 416zM567.8 416h-47.5C480.4 416 448 449.5 448 490.7C448 502.4 457.3 512 468.8 512h150.3C630.7 512 640 502.4 640 490.7C640 449.5 607.6 416 567.8 416zM256.2 320c0 35.26 28.57 63.85 63.79 63.98C355.2 383.8 383.8 355.3 383.8 320S355.2 256.2 320 256C284.8 256.2 256.2 284.7 256.2 320zM335.7 320c0 8.775-7.139 15.94-15.55 15.98C311.4 335.9 304.3 328.8 304.3 320c0-8.717 7.041-15.85 15.73-15.97C328.7 304.2 335.7 311.3 335.7 320zM119.8 416h-47.5C32.42 416 0 449.5 0 490.7C0 502.4 9.34 512 20.83 512h150.3C182.7 512 192 502.4 192 490.7C192 449.5 159.6 416 119.8 416zM32.21 320c0 35.26 28.57 63.85 63.79 63.98C131.2 383.8 159.8 355.3 159.8 320S131.2 256.2 96 256C60.78 256.2 32.21 284.7 32.21 320zM111.7 320c0 8.775-7.139 15.94-15.55 15.98C87.41 335.9 80.27 328.8 80.27 320c0-8.717 7.041-15.85 15.73-15.97C104.7 304.2 111.7 311.3 111.7 320z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faScreenUsers = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;